module.exports = __webpack_public_path__ + "static/media/calling-all-reactive-agents.c2c0a67f.txt";